import { v4 as uuidv4 } from 'uuid';
import { getLocalUserUUID } from '../../features/base/localuser';
import { ROLE } from '../../features/base/participants';
import { getDisplayName } from '../../features/base/settings';
import { command } from './comand';
export default function TempMate() {
    this.connecting = false;
    this.group_id = null;
    this.websocket = null;
} 

TempMate.prototype.constructor = TempMate;
TempMate.prototype.init = function(handler) {
    // this.handler = handler;

    if (!this.connecting) this.connection();
}

TempMate.prototype.setHandler = function(handler) {
    this.handler = handler;

    // if (!this.connecting) this.connection();
}

TempMate.prototype.setWebsocket = function(websocket, connecting) {
    this.websocket = websocket;
    this.connecting = connecting;

    if (connecting === false) {
        this.group_id = null;
    }
}
// 입장 
TempMate.prototype.join = async function(group_id) {
    if (!group_id) return;
    this.group_id = group_id;
    const nickname = getDisplayName(APP.store.getState());
    const password = APP.store.getState()['features/room-lock'].password;

    this.sendCommand(command['join-room'], { 
        password,
        nickname,
        type: "hidden",
        role_name_forced: null
});
}
// 채팅 
TempMate.prototype.sendTextMessage = function(message) {
    this.sendCommand(command['send-text'], { message: JSON.stringify(message) });
}
TempMate.prototype.sendPrivateTextMessage = function(participants, message) {
    participants.map(p => {
        this.sendCommand(command['send-private-text'], { message: JSON.stringify(message), 
            user_uuid: p.id });
    });
}

// 연결 해제
TempMate.prototype.leave =  function() {
    this.sendCommand(command['left-room'], null);
}
// 연결
TempMate.prototype.connection = function() {
    const websocket = new WebSocket(`wss://${location.host}/svc/room/ws?group_${new Date().getTime()}`);

    const handlerWebsocket = (websocket, connecting) => this.setWebsocket(websocket, connecting);
    websocket.addEventListener('open', () => {
        
        handlerWebsocket(websocket, true);

        // set auth
        const access_token = APP.mateManagement.getAccessToken();
        
        this.sendCommand(command['auth-setting'], { access_token });
    });

    websocket.addEventListener('close', () => {
        console.log("close")
        handlerWebsocket(websocket, false);
    });
    
    websocket.addEventListener('error', ev => {
        console.log(ev)
        handlerWebsocket(websocket, false);
    });

    websocket.addEventListener('message', (event) => {
        this.reciveCommand(event);   
    }); 
} 
// 연결 끊기
TempMate.prototype.disconnection = function() {

}

TempMate.prototype.sendCommand = function(name, payload) {
    const websocket = this.websocket;
    if (!websocket) return;
    try {
        const uuid = uuidv4();
        const cmdReqData = Object.assign({
            class: name,
            id: uuid,
            payload
        });

        const meeting_id = APP.mateManagement.getMeetingId();
        
        cmdReqData.payload = {
            ...payload,
            meeting_id,
            group_id: this.group_id
        };
        websocket.send(JSON.stringify(cmdReqData));
    } catch (err) {
        console.log(err);
    }
}

TempMate.prototype.reciveCommand = function(event) {
    let { data } = event;            

    try {
        data = JSON.parse(data);
    } catch (err) {
        console.log(err);
        data = JSON.parse(data);
    }

    if (data.status && data.status !== 200 ) {
        switch (data.class) {
            case command['left-room']:
                return;

            default:
                const message = data.payload?.message?.message?.format;
                if (message) alert(message);
                return;
        }
        return;
    }
    
    switch (data.class) {
        case command['auth-setting']:
            this.handler.showLoading(false);
            break;

        case command['join-room']:
            this.handler.showLoading(false);
            this.handler.setParticipant(data.payload.members, data.payload.group_id);
            break;
        
        case command['left-room']:
            break;

        case `Event.${command['send-text']}`:
        case `Event.${command['send-private-text']}`:
            this.handler.setChat(data.payload);
            break;

        case `Event.${command['join-room']}ed`:
            this.handler.joinParticipant(data.payload);
            break;
        case `Event.${command['left-member-room']}`:
            this.handler.leftParticipant(data.payload);

        case `Event.${command['set-role']}`:
            this.handler.changeParticipantRole(data.payload);
    }
}

